import styled from 'styled-components';
import {BREAKPOINTS} from "../../../../app/appConstants";

export const LoginWrapperStyled = styled.div`
    display: flex;
    flex-direction: column;

    > a {
        color: unset;
        text-decoration: underline;
    }
`;
export const LoginWrapperHeaderStyled = styled.div`
    margin: 0;
    padding: 48px;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    background: var(--app-bg-header-color);
  
    @media (max-width: ${BREAKPOINTS.large}px) {
        padding: 20px;
    }
    @media (max-width: ${BREAKPOINTS.small}px) {
        padding: 16px;
        background: var(--color-base);
    }
`;
export const LoginWrapperContentStyled = styled.div`
    flex: 1 1 auto;
`;
export const LoginWrapperMenuStyled = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;

    font-size: 16px;
    font-weight: 600;

    > button {
        line-height: 32px;
    }
    > *:not(:last-child) {
        margin-right: 16px;
    }
`;

export const LoginWrapperLangChooserContainerStyled = styled.div`
    display: flex;
    align-items: center;
`;

export const LoginStyled = styled.div`
    width: 464px;
    margin: 64px auto;
    @media (max-width: ${BREAKPOINTS.small}px) {
        margin: 0 auto;
        width: 100%;
        background: var(--app-bg-modal-color);
    }
`;

export const LoginBoxStyled = styled.div`
    font-size: 16px;
    background: var(--app-bg-modal-color);
    box-shadow: 0 0 25px rgba(0, 0, 0, 0.25);
    border-radius: 2px;
    padding: 32px 40px 48px;
    position: relative;
    @media (max-width: ${BREAKPOINTS.small}px) {
        box-shadow: none;
        padding: 24px 16px;
    }
`;

export const LogoStyled = styled.div`
    color: rgb(255, 221, 60);
`;

export const LoginBoxAcceptTermsContainerStyled = styled.div`
    label a {
        color: var(--text-color-secondary);
        font-weight: 600;
    }
    .form-check .form-check-input[type=checkbox].is-invalid {
        border-color: var(--color-negative);
    }
    .form-check-input.is-invalid~.form-check-label {
        color: var(--text-color-secondary);
    }
`;

export const LoginForgotPasswordLinkContainerStyled = styled.div`
    display: flex;
    justify-content: end;
    margin-bottom: 32px;
    
    a {
        color: var(--color-white);
    }
`;
